<template>
  <div ref="container">
    <a-modal :z-index="99" :title="title" width="90%" :visible="visible"
             :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}"
             :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false"
             @cancel="handleCancel" cancelText="关闭" style="top:20px;">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper" style="margin-bottom: 20px">
        <a-input v-model="topQueryParam.keywords" placeholder="请输入产品名称或DI编码" style="width: 400px;margin-right: 20px"></a-input>
        <a-button type="primary" @click="getList">查询</a-button>
      </div>
      <!-- table区域-begin -->
      <a-table bordered ref="table" size="middle" :pagination="ipagination"
               rowKey="id" :columns="columns" :dataSource="dataSource"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               :loading="loading" @change="getList">
      </a-table>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">取消</a-button>
        <a-button key="ok" type="primary" @click="submit">确认</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import { authorizeList, batchDetails } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'MaterialInOutList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JEllipsis,
  },
  data() {
    return {
      loading: false,
      title: '操作',
      visible: false,
      disableMixinCreated: false,
      toFromType: '',
      currentMaterialId: '',
      dataSource: [],
      fileName: '',
      uuid: '',
      url: {
        list: '/authorize/authorizeList',
      },
      type:'',
      // 表头
      columns: [  ],
      labelCol: {
        xs: { span: 1 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 16 },
      },
    }
  },
  created() {},
  methods: {
    async show(type,chooseData) {

      if(!chooseData || chooseData.length == 0){
        this.selectedRowKeys = []
        this.selectionRows = []
      }else{
        this.selectionRows = chooseData
        this.selectedRowKeys = chooseData.map(x=>x.id)
      }

      this.type = type
      this.visible = true
      this.getList()
    },

    async getList (pagination, filters, sorter) {
      if (pagination && pagination.current) {
        this.ipagination = pagination
      }
      const res = await authorizeList({
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        keywords: this.topQueryParam.keywords,
        type:this.type
      })
      this.dataSource = res.records.data.list
      this.ipagination.total = res.records.data.total

      let cols = []
      for (const t in res.titles) {
        cols.push({
          "title": res.titles[t],
          "dataIndex": t
        })
      }
      console.log('===>>>',cols,res.titles)
      this.columns = cols
    },
    close() {
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    submit(){
      this.$emit('ok',this.selectionRows,this.columns)
      this.close()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>